import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ReviewPage} from './review/review.page';
import {ReviewReportPage} from './report/review-report.page';
import {ReviewReportListPage} from './review-report-list/review-report-list.page';
import {ReviewFeedbackPage} from './feedback/review-feedback.page';
import {ReviewReportPrintPage} from './report-print/review-report-print.page';
import {ReviewReportOne2OnePage} from './report-one2one/review-report-one2one.page';
import {ReviewReportOne2OnePrintPage} from './report-one2one-print/review-report-one2one-print.page';

const routes: Routes = [
    {
        path: '',
        component: ReviewPage
    },
    {
        path: 'my/report/one2one',
        component: ReviewReportOne2OnePage,
        data: { level: 'learner', type: 'one2one' }
    },
    {
        path: 'my/report/one2one/:report_id',
        component: ReviewReportOne2OnePage,
        data: { level: 'learner', type: 'one2one' }
    },
    {
        path: 'my/report/one2one/:report_id/print',
        component: ReviewReportOne2OnePrintPage,
        data: { level: 'learner', type: 'one2one' }
    },
    {
        path: 'my/report',
        component: ReviewReportPage,
        data: { level: 'learner', type: 'review' }
    },
    {
        path: 'my/report/:report_id',
        component: ReviewReportPage,
        data: { level: 'learner', type: 'review' }
    },
    {
        path: 'my/report/:report_id/print',
        component: ReviewReportPrintPage,
        data: { level: 'learner', type: 'review' }
    },
    {
        path: 'team/:delegate_id',
        component: ReviewReportListPage
    },
    {
        path: 'report/one2one/:report_id',
        component: ReviewReportOne2OnePage,
        data: { level: 'manager', type: 'one2one' }
    },
    {
        path: 'report/one2one/:report_id/print',
        component: ReviewReportOne2OnePrintPage,
        data: { level: 'manager', type: 'one2one' }
    },
    {
        path: 'report/:report_id',
        component: ReviewReportPage,
        data: { level: 'manager', type: 'review' }
    },
    {
        path: 'report/:report_id/print',
        component: ReviewReportPrintPage,
        data: { level: 'manager', type: 'review' }
    },
    {
        path: 'feedback/:report_id',
        component: ReviewFeedbackPage,
        data: { level: 'manager' }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ReviewRoutingModule {
}
